import React, { PropsWithChildren, useContext } from 'react';
import classNames from 'classnames';

import { media } from 'context';
import { Animate, DS_CLASS_NAME, Img, Layout } from 'ds';

interface Props {
  animateIn?: boolean;
  thinking?: boolean;
}

const AIAssistantSystemMessage: React.FC<PropsWithChildren<Props>> = ({ children, animateIn, thinking = false }) => {
  const { isMobile } = useContext(media);
  const content = (
    <Layout align="flex-start" flexShrink={0}>
      {!isMobile && (
        <Layout width={40} height={40} minWidth={40} minHeight={40} flexShrink={0} key="ai-assistant-icon">
          <Img
            srcKey={'new_version_Ivy_Icon_3d_2UmlF3Tey.png'}
            alt="AI Assistant Avatar"
            width={400}
            height={400}
            folder="ux"
            className={thinking ? 'ai-assistant-thinking-avatar' : ''}
          />
        </Layout>
      )}
      <Layout
        color="white"
        paddingY={thinking || isMobile ? undefined : 8}
        marginLeft={isMobile ? 24 : 12}
        borderTopRightRadius={16}
        borderBottomRightRadius={16}
        borderTopLeftRadius={16}
        minHeight={40}
      >
        {/*
          Use a div with Text typography classes — not <Text> / <p> — so children may include
          block elements (e.g. Layout) without validateDOMNesting(div inside p).
        */}
        <div className={classNames('Text', DS_CLASS_NAME, 'is-body-md', 'is-scaled')}>{children}</div>
      </Layout>
    </Layout>
  );

  if (animateIn) {
    return <Animate>{content}</Animate>;
  }
  return content;
};

export default AIAssistantSystemMessage;
